
define('template!webshopLandingpagesDetailBodyLandingpageBodyView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="left">\n    <div class="landingpage-code item">\n        <div class="libelle">' +
((__t = ( _.i18n('common.code') )) == null ? '' : __t) +
'</div>\n        <input type="text" class="value">\n    </div>\n    <div class="domain item">\n        <div class="libelle">' +
((__t = ( _.i18n('common.domain') )) == null ? '' : __t) +
'</div>\n        <div class="domain-region"></div>\n    </div>\n    <div class="category item">\n        <div class="libelle">' +
((__t = ( _.i18n('common.category') )) == null ? '' : __t) +
'</div>\n        <div class="category-select-region"></div>\n    </div>\n    <div class="template item">\n        <div class="libelle">' +
((__t = ( _.i18n('common.template') )) == null ? '' : __t) +
'</div>\n        <div class="template-region"></div>\n    </div>\n</div>\n<div class="right"> \n  <div class="indexes-region"></div>\n</div>';

}
return __p
};});

